import React, { Component } from "react";
import Select from "react-select";
import $ from "jquery";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Swal from "sweetalert2";
import Axios from "axios";
import update from "immutability-helper";
import { validated } from "react-custom-validation";
import { apiUrl, adminlimit, downloadUrl } from "../../Settings/Config";
import api from "../../../utils/axios";
import {
  showContaimerLoader,
  encodeValue,
  removeItem,
  showPageCount,
  removeChar,
  isEmpty,
  showLoader,
  hideLoader,
  showAlert,
  isSingleSelect,
  jsUcfirstFun,
  onlyNumberDot,
  apiDate,
  validateDate,
  showDate,
  hasPermission,
} from "../../Settings/Settings";
import Pagenation from "../../Layout/Pagenation";
const module = "candidatemedicals";
const modulePath = "/candidate";
const moduleName = "Medical Details";
const moduleID = 24;
const today = new Date();
today.setHours(0, 0, 0, 0);
class List extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pageLimit: { label: adminlimit, value: adminlimit },
      loading: true,
      totalRecords: 0,
      totalPage: 0,
      currentPage: 1,
      listdata: [],
      name: "",
      status: "",
      hospitalList: [],
      editID: "",
      postdata: {
        hospitalName: "",
        place: "",
        date: "",
        expiry_date: "",
        done_by: "",
        status: "",
        amount: "",
        medicalFile: "",
      },
      detaildata: [],
      viewDocumentTitle: "",
      viewDocumentFile: "",
      viewfileType: "",
      restForm: false,
    };
    this.handleChangeText = this.handleChangeText.bind(this);
  }

  componentDidMount() {
    this.loadList(1);
    this.loadDropdown();
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.state.formpost !== nextProps.formpost && this.props.formpost !== nextProps.formpost) {
      if (nextProps.formpost.length > 0) {
        hideLoader("submit_medical_frm");
        const errMsg = nextProps.formpost[0].message;
        if (nextProps.formpost[0].status === "ok") {
          showAlert("Success", errMsg, "success", "No");
          this.props.history.push(modulePath);
        } else {
          showAlert("Error", errMsg, "error", "No");
        }
      }
    }
  }
  searchList(e) {
    e.preventDefault();
    this.setState({ loading: true, currentPage: 1 }, () => {
      this.loadList(1);
    });
  }
  resetSearch(e) {
    e.preventDefault();
    this.setState(
      {
        loading: true,
        name: "",
        status: "",
        currentPage: 1,
      },
      () => {
        this.loadList(1);
      },
    );
  }
  loadList(offset) {
    this.setState({ loading: true });
    let addParams = "";
    if (this.state.name !== "") {
      addParams += "&name=" + this.state.name;
    }
    if (this.state.status !== null && Object.keys(this.state.status).length > 0) {
      addParams += "&status=" + this.state.status.value;
    }
    try {
      api
        .get(`${module}?limit=${this.state.pageLimit.value}&offset=${offset}&candidateId=${this.props.candidateID}${addParams}`)
        .then((res) => {
          if (res.data.status === "ok") {
            this.setState({ listdata: res.data.result, loading: false, totalRecords: res.data.totalRecords, totalPage: res.data.totalPages });
          }
        })
        .catch((err) => {
          console.error(err);
          this.setState({ loading: false, totalRecords: 0, totalPage: 0, currentPage: 1, listdata: [] });
        });
    } catch (e) {
      this.setState({ loading: false, totalRecords: 0, totalPage: 0, currentPage: 1, listdata: [] });
    }
  }
  loadDropdown() {
    api
      .get("hospital/dropdown")
      .then((res) => {
        if (res.data.status === "ok") {
          this.setState({ hospitalList: res.data.result });
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }
  edit(editID, e) {
    e.preventDefault();
    this.setState({ editID: editID }, () => {
      api
        .get(`${module}/detail/${encodeValue(editID)}`)
        .then((res) => {
          if (res.data.status === "ok") {
            $("#addNewmedical").trigger("click");
            const result = res.data.result;
            this.setState({
              postdata: {
                hospitalName:
                  result.hospitalName !== "" && result.hospitalName !== null && result.hospitalNameLabel !== "" && result.hospitalNameLabel !== null
                    ? { label: result.hospitalNameLabel, value: parseInt(result.hospitalName) }
                    : "",
                place: result.place || "",
                date: validateDate(result.date),
                expiry_date: validateDate(result.expiry_date),
                done_by: result.done_by !== "" && result.done_by !== null ? { label: jsUcfirstFun(result.done_by), value: result.done_by } : "",
                status: result.status !== "" && result.status !== null ? { label: jsUcfirstFun(result.status), value: result.status } : "",
                amount: result.amount || "",
                medicalFile: result.upload !== "" && result.upload !== null ? `${downloadUrl}views/public/uploads/medical/${result.upload}` : "",
              },
            });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    });
  }
  sateValChange = (field, value) => {
    if (field === "page") {
      this.setState(
        {
          loading: true,
          currentPage: value,
        },
        () => {
          this.loadList(value);
        },
      );
    } else if (field === "pageLimit") {
      this.setState({ pageLimit: value, currentPage: 1 }, () => {
        this.loadList(1);
      });
    } else if (field === "restForm") {
      this.setState({ restForm: value });
    }
  };
  handleChangeText(event) {
    const name = event.target.name;
    const value = event.target.value;
    this.setState({ [name]: value });
  }
  handleSelectChange(name, value) {
    this.setState({ [name]: value });
  }
  removeItem(deleteID, e) {
    e.preventDefault();
    removeItem(deleteID, module, this.sateValChange, this.state.currentPage);
  }
  changeStatus(docID, e) {
    e.preventDefault(); 
    Swal.fire({
      title: "Are you sure?",
      text: "You want change status this item!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, change it!",
      customClass: {
        confirmButton: "btn btn-primary me-3 waves-effect waves-light",
        cancelButton: "btn btn-label-secondary waves-effect",
      },
      buttonsStyling: false,
      showLoaderOnConfirm: true,
      preConfirm: () => {
        try {
          return Axios.put(`${apiUrl}${module}/updatestatus/${docID}`, {candidateId:this.props.candidateID}, {
            headers: {
              Authorization: `${localStorage.getItem("token")}`,
            },
          })
            .then((res) => {
              return res.data;
            })
            .catch((e) => {
              console.log(e);
              return e?.response?.data ?? { success: false, message: e.message };
            });
        } catch (err) {
          console.log(err);
        }
      },
      allowOutsideClick: () => !Swal.isLoading(),
    }).then((result) => {
      const value = result?.value ?? "";
      if (value !== "") {
        if (result.value.status === "ok") {
          Swal.fire({
            icon: "success",
            title: "Deleted!",
            text: result.value.message,
            customClass: {
              confirmButton: "btn btn-success waves-effect",
            },
          }).then(() => {
            this.sateValChange("page", this.state.currentPage, moduleName);
          });
        } else {
          Swal.fire({
            title: "Alert",
            text: result.value.message,
            icon: "error",
            customClass: {
              confirmButton: "btn btn-danger waves-effect",
            },
          });
        }
      }
    });

  }
  
  fieldChange = (field, value) => {
    if (field === "amount") {
      value = onlyNumberDot(value);
    }
    this.setState(update(this.state, { postdata: { [field]: { $set: removeChar(value) } } }));
  };

  handleSubmit = () => {
    showLoader("submit_medical_frm");
    const postData = this.state.postdata;

    const postObject = {
      candidateId: this.props.candidateID,
      hospitalName: postData.hospitalName?.value || "",
      place: postData.place.toUpperCase(),
      date: apiDate(postData.date),
      expiry_date: apiDate(postData.expiry_date),
      done_by: postData.done_by?.value ?? "",
      status: postData.status?.value ?? "",
      amount: postData.amount || "",
    };

    const formPayload = new FormData();
    let error = "";
    const fileInput = document.getElementById("medicalFile");
    const file = fileInput?.files?.[0];
    if (file) {
      if (file.type !== "application/pdf") {
        error += "Document PDF only allowed";
      } else {
        formPayload.append("medicalFile", file);
      }
    }

    if (error !== "") {
      showAlert("Error", error, "error");
      return false;
    }
    Object.keys(postObject).forEach((key) => {
      formPayload.append(key, postObject[key]);
    });

    let post_url = `${module}`;
    let method = "post";
    if (this.state.editID !== "") {
      post_url = `${module}/${encodeValue(this.state.editID)}`;
      method = "put";
    }
    api[method](post_url, formPayload)
      .then((res) => {
        hideLoader("submit_medical_frm");
        $(".btn-close").trigger("click");
        const errMsg = res.data.message;
        if (res.data.status === "ok") {
          showAlert("Success", errMsg, "success", "No");
          this.loadList(1);
          this.resetFrom();
        }
      })
      .catch((err) => {
        hideLoader("submit_medical_frm");
        const errMsg = err.response.data?.message || err?.message;
        showAlert("Error", errMsg, "error", "No");
        console.error(err);
      });
  };
  viewFile(viewDocumentFile, viewfileType, viewDocumentTitle, e) {
    e.preventDefault();
    window.open(`${downloadUrl}views/public/uploads/medical/${viewDocumentFile}`, '_blank');
   /*  this.setState({ viewDocumentFile, viewDocumentTitle, viewfileType }, () => {
      $("#addNewmedical").trigger("click");
    }); */
  }
  closePopup() {
    this.setState({ viewDocumentFile: "", viewDocumentTitle: "" }, () => {
      this.resetFrom();
    });
  }
  resetFrom() {
    this.setState({
      editID: "",
      restForm: true,
      postdata: {
        hospitalName: "",
        place: "",
        date: "",
        expiry_date: "",
        done_by: "",
        status: "",
        amount: "",
        medicalFile: "",
      },
    });
  }

  render() {
    return (
      <div className="main-container container-fluid mx-3">
        <div className="page-header">
          <h1 className="page-title">Medical Details</h1>
          <div>
            {hasPermission(moduleID, "add") && (
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <button
                    className="btn btn-sm btn-success badge mx-4"
                    type="button"
                    data-bs-toggle="modal"
                    data-bs-target="#medicalmodal"
                    data-backdrop="static"
                    data-keyboard="false"
                    id="addNewmedical"
                  >
                    <i className="fa fa-plus"></i> Add New
                  </button>
                </li>
              </ol>
            )}
          </div>
        </div>
        <div className="row">
          <div className="col-md-12 col-xl-12">
            <div className="card">
              <div className="card-body">
                <div className="form-row">
                  <div className="col-md-3">
                    <input type="text" className="form-control" placeholder={"Search keyword"} name="name" onChange={this.handleChangeText} value={this.state.name} />
                  </div>
                  <div className="col-md-3">
                    <a href="/" className="btn btn-primary" onClick={this.searchList.bind(this)}>
                      Search
                    </a>
                    <a href="/" className="btn btn-secondary offset-1" onClick={this.resetSearch.bind(this)}>
                      Reload
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-xl-12">
            <div className="card">
              {this.state.loading ? (
                showContaimerLoader()
              ) : (
                <div>
                  <div className="card-header">
                    {parseInt(this.state.totalPage) > 0 && showPageCount(moduleName, this.state.currentPage, this.state.totalPage, this.state.totalRecords, this.sateValChange, this.state.pageLimit)}
                  </div>
                  <div className="card-body">
                    <div className="table-responsive">
                      <table className="table border text-nowrap text-md-nowrap table-bordered mb-0">
                        <thead className="table-primary">
                          <tr>
                            {(hasPermission(moduleID, "edit") || hasPermission(moduleID, "delete")) && <th className="text-center">Actions </th>}
                            <th>S.No.</th>
                            <th>Hospital</th>
                            <th>Place</th>
                            <th>Issue Date</th>
                            <th>Expiry Date</th>
                            <th>Done By</th>
                            <th>Status</th>
                            <th>Amount</th>
                            <th>Medical Document</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.listdata.length > 0 ? (
                            this.state.listdata.map((item, index) => {
                              let expiry = false;
                              if (item.expiry_date !== "1970-01-01" && item.expiry_date !== null && item.expiry_date !== "" && item.activeStatus==='A') {
                                const expiryDate_ = new Date(item.expiry_date);
                                expiryDate_.setHours(0, 0, 0, 0);
                                if (expiryDate_ < today) {
                                  expiry = true;
                                }
                              }

                              return (
                                <tr key={index} className={expiry ? "bg-danger text-white" : ""}>
                                  <td className={`text-center text-nowrap ${item.activeStatus==='I'?"bg-danger text-white" : ""}`}  valign="top">
                                    {hasPermission(moduleID, "edit") && (
                                      <a href="/" onClick={this.edit.bind(this, item.id)} className="me-2">
                                        <i className="fa fa-pencil-square-o"></i>
                                      </a>
                                    )}
                                    {hasPermission(moduleID, "delete") && (
                                      <a href="/" className="delete_record" onClick={this.removeItem.bind(this, encodeValue(item.id))}>
                                        <i className="fa fa-trash"></i>
                                      </a>
                                    )}
                                    <a href="/" className="delete_record mx-2" onClick={this.changeStatus.bind(this, encodeValue(item.id))}>
                                      <i className={`fa ${item.activeStatus==='I'?'fa-lock':'fa-unlock-alt'}`} aria-hidden="true"></i>
                                    </a>
                                  </td>
                                  <td>{(parseInt(this.state.currentPage) - 1) * parseInt(this.state.pageLimit.value) + (parseInt(index) + 1)}</td>
                                  <td>{item.hospitalNameLabel || "-"}</td>
                                  <td>{item.place}</td>
                                  <td>{showDate(item.date)}</td>
                                  <td>{showDate(item.expiry_date)}</td>
                                  <td>{jsUcfirstFun(item.done_by)}</td>
                                  <td>{jsUcfirstFun(item.status)}</td>
                                  <td>{item.amount}</td>
                                  <td className="text-center">
                                    {item.medicalFile !== "" && (
                                      <a href="/" onClick={this.viewFile.bind(this, item.upload, "medicalFile", "Medical Document")}>
                                        <i className="fa fa-file-pdf-o" aria-hidden="true"></i>
                                      </a>
                                    )}
                                  </td>
                                </tr>
                              );
                            })
                          ) : (
                            <tr>
                              <td className="text-center" colSpan={10}>
                                No {moduleName} Found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                    {parseInt(this.state.totalPage) > 1 && (
                      <Pagenation
                        params={{
                          totalRecords: this.state.totalRecords,
                          totalPage: this.state.totalPage,
                          currentPage: this.state.currentPage,
                        }}
                        sateValChange={this.sateValChange}
                      />
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="modal fade" id="medicalmodal" tabIndex="-1" role="dialog" data-bs-backdrop="static" data-bs-keyboard="false">
          <div className="modal-dialog modal-xl" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">{this.state.viewDocumentFile !== "" ? `View ${this.state.viewDocumentTitle}` : `${this.state.editID !== "" ? "Update" : "Add New"} Document`}</h5>
                <button className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={this.closePopup.bind(this)}>
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              {this.state.viewDocumentFile !== "" ? (
                <div>
                  <iframe src={`${downloadUrl}views/public/uploads/medical/${this.state.viewDocumentFile}`} width="100%" height="500px" title="view File1"></iframe>
                  <div className="modal-footer">
                    <button className="btn btn-secondary" data-bs-dismiss="modal" aria-label="Close" onClick={this.closePopup.bind(this)}>
                      Close
                    </button>
                  </div>
                </div>
              ) : (
                <PostForm
                  {...this.props}
                  fields={this.state.postdata}
                  hospitalList={this.state.hospitalList}
                  restForm={this.state.restForm}
                  sateValChange={this.sateValChange}
                  onChange={this.fieldChange}
                  onValid={this.handleSubmit}
                  closePopup={this.closePopup.bind(this)}
                  editID={this.state.editID}
                  error_msg={this.state.error_msg}
                  onInvalid={() => {
                    console.log("Form invalid!");
                  }}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default List;

function validationConfig(props) {
  const { hospitalName, place, date, expiry_date, done_by, status, medicalFile } = props.fields;

  return {
    fields: ["hospitalName", "place", "date", "expiry_date", "done_by", "status", "medicalFile"],
    validations: {
      hospitalName: [[isEmpty, hospitalName]],
      place: [[isEmpty, place]],
      date: [[isEmpty, date]],
      expiry_date: [[isEmpty, expiry_date]],
      done_by: [[isSingleSelect, done_by]],
      status: [[isSingleSelect, status]],
      medicalFile: [[isEmpty, medicalFile]],
    },
  };
}
class PostForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showPDF: false,
      viewType: "",
      restData: false,
    };
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.restForm === true) {
      this.props.sateValChange("restForm", false);
      setTimeout(() => {
        this.handleReset();
      }, 1000);
    }
  }
  handleSelectChange(name, value) {
    this.props.onChange(name, value);
  }
  handleChangeFile(name, value) {
    this.props.onChange(name, value);
  }
  handleFileChange = (e) => {
    const file = e.target.files[0];
    const name = e.target.name;
    if (file) {
      const previewUrl = URL.createObjectURL(file);
      this.props.onChange(name, previewUrl);
    }
  };
  viewFile(viewType, e) {
    e.preventDefault();
    window.open(`${this.props.fields[viewType]}`, '_blank');
    //this.setState({ showPDF: !this.state.showPDF, viewType });
  }

  handleReset = () => {
    const { $validation } = this.props;
    // 2️⃣ Reset all validation errors
    Object.keys($validation).forEach((key) => {
      if ($validation[key]) {
        $validation[key].show = false;
        $validation[key].error = {};
      }
    });
    this.setState({ restData: this.state.restData });
  };

  render() {
    const { fields, onChange, onValid, onInvalid, $field, $validation } = this.props;
    let errMsghospitalName,
      errMsgplace,
      errMsgdate,
      errMsgexpiry_date,
      errMsgdone_by,
      errMsgstatus,
      errMsgmedicalFile = "";
    if ($validation.hospitalName.error.reason !== undefined) {
      errMsghospitalName = $validation.hospitalName.show && <span className="error">{$validation.hospitalName.error.reason}</span>;
    }
    if ($validation.place.error.reason !== undefined) {
      errMsgplace = $validation.place.show && <span className="error">{$validation.place.error.reason}</span>;
    }
    if ($validation.date.error.reason !== undefined) {
      errMsgdate = $validation.date.show && <span className="error">{$validation.date.error.reason}</span>;
    }
    if ($validation.expiry_date.error.reason !== undefined) {
      errMsgexpiry_date = $validation.expiry_date.show && <span className="error">{$validation.expiry_date.error.reason}</span>;
    }
    if ($validation.done_by.error.reason !== undefined) {
      errMsgdone_by = $validation.done_by.show && <span className="error">{$validation.done_by.error.reason}</span>;
    }
    if ($validation.status.error.reason !== undefined) {
      errMsgstatus = $validation.status.show && <span className="error">{$validation.status.error.reason}</span>;
    }
    if ($validation.medicalFile.error.reason !== undefined) {
      errMsgmedicalFile = $validation.medicalFile.show && <span className="error">{$validation.medicalFile.error.reason}</span>;
    }

    return (
      <>
        <div style={{ display: !this.state.showPDF ? "none" : "" }}>
          {this.state.showPDF && this.state.viewType !== "" && <iframe src={`${fields[this.state.viewType]}`} width="100%" height="500px" title="view File"></iframe>}
          <div className="modal-footer">
            <button className="btn btn-secondary" onClick={this.viewFile.bind(this, "medicalFile")}>
              Back
            </button>
          </div>
        </div>
        <div style={{ display: this.state.showPDF ? "none" : "" }}>
          <div className="modal-body">
            <div className="form-group">
              <div className="form-row">
                <div className="form-group col-md-3">
                  <label className="form-label">
                    Hospital<span className="lbl-error">*</span>
                  </label>
                  <Select value={fields.hospitalName} onChange={this.handleSelectChange.bind(this, "hospitalName")} placeholder="Select Hospital" options={this.props.hospitalList} />
                  {errMsghospitalName}
                </div>
                <div className="form-group col-md-3">
                  <label className="form-label">
                    Place<span className="lbl-error">*</span>
                  </label>
                  <input type="text" className="form-control upper-case" placeholder="Place" name="place" value={fields.place} {...$field("place", (e) => onChange("place", e.target.value))} />
                  {errMsgplace}
                </div>
                <div className="form-group col-md-3">
                  <label className="form-label">
                    Issue Date<span className="lbl-error">*</span>
                  </label>
                  <DatePicker
                    peekNextMonth
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    placeholderText="Select Issue Date"
                    className="form-control"
                    onKeyDown={(e) => e.preventDefault()}
                    selected={fields.date}
                    dateFormat="dd-MM-yyyy"
                    onChange={this.handleSelectChange.bind(this, "date")}
                  />
                  {errMsgdate}
                </div>
                <div className="form-group col-md-3">
                  <label className="form-label">Expiry Date</label>
                  <DatePicker
                    peekNextMonth
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    placeholderText="Select Expiry Date"
                    className="form-control"
                    onKeyDown={(e) => e.preventDefault()}
                    selected={fields.expiry_date}
                    dateFormat="dd-MM-yyyy"
                    onChange={this.handleSelectChange.bind(this, "expiry_date")}
                    minDate={fields.date !== "" ? fields.date : ""}
                  />
                  {errMsgexpiry_date}
                </div>
                <div className="form-group col-md-3">
                  <label className="form-label">
                    Done By<span className="lbl-error">*</span>
                  </label>
                  <Select
                    value={fields.done_by}
                    onChange={this.handleSelectChange.bind(this, "done_by")}
                    placeholder="Select Done By"
                    options={[
                      { label: "Officer", value: "officer" },
                      { label: "Agent", value: "agent" },
                      { label: "Self", value: "self" },
                    ]}
                  />
                  {errMsgdone_by}
                </div>
                <div className="form-group col-md-3">
                  <label className="form-label">
                    Status<span className="lbl-error">*</span>
                  </label>
                  <Select
                    value={fields.status}
                    onChange={this.handleSelectChange.bind(this, "status")}
                    placeholder="Select Status"
                    options={[
                      { label: "Fit", value: "fit" },
                      { label: "Unfit", value: "unfit" },
                    ]}
                  />
                  {errMsgstatus}
                </div>
                <div className="form-group col-md-3">
                  <label className="form-label">Amount</label>
                  <input type="text" className="form-control upper-case" placeholder="Amount" name="amount" value={fields.amount} {...$field("amount", (e) => onChange("amount", e.target.value))} />
                </div>
                <div className="form-group col-md-3">
                  <div className="form-group">
                    <label className="form-label">Medical Document</label>
                    <div className="input-group">
                      <input className="form-control" type="file" name="medicalFile" id="medicalFile" accept="application/pdf" onChange={this.handleFileChange} />
                      {fields.medicalFile !== "" && (
                        <a href="/" onClick={this.viewFile.bind(this, "medicalFile")}>
                          <span className="input-group-text btn btn-secondary shadow-none" title="View Document" style={{ margin: 0, height: "100%" }}>
                            <i className="fa fa-file-pdf-o" aria-hidden="true"></i>
                          </span>
                        </a>
                      )}
                      {errMsgmedicalFile}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button className="btn btn-secondary" data-bs-dismiss="modal" aria-label="Close" onClick={this.props.closePopup.bind(this)}>
              Close
            </button>
            <button
              className="btn btn-primary"
              id="submit_medical_frm"
              onClick={(e) => {
                e.preventDefault();
                this.props.$submit(onValid, onInvalid);
              }}
            >
              Save changes
            </button>
          </div>
        </div>
      </>
    );
  }
}
PostForm = validated(validationConfig)(PostForm);
